import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`HostJane is here to make sure any money passing between Buyers and Sellers gets exchanged fairly, and in broad daylight.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      